module.exports = __webpack_public_path__ + "static/media/Reimbursement.58d95ede.svg";